module.exports = __webpack_public_path__ + "static/assets/98f292231471a336fbb8c54284e935ce.png";